import React, { useMemo } from 'react';
import { Calendar } from 'lucide-react';
import { ui } from './styles';

const MONTHS = [
  { value: '01', label: 'Janeiro' },
  { value: '02', label: 'Fevereiro' },
  { value: '03', label: 'Março' },
  { value: '04', label: 'Abril' },
  { value: '05', label: 'Maio' },
  { value: '06', label: 'Junho' },
  { value: '07', label: 'Julho' },
  { value: '08', label: 'Agosto' },
  { value: '09', label: 'Setembro' },
  { value: '10', label: 'Outubro' },
  { value: '11', label: 'Novembro' },
  { value: '12', label: 'Dezembro' },
];

function buildYears(range = 8) {
  const current = new Date().getFullYear();
  const start = current - Math.floor(range / 2);
  return Array.from({ length: range }, (_, index) => start + index);
}

function currentYear() {
  return String(new Date().getFullYear());
}

export default function MonthYearField({
  id,
  value,
  onChange,
  error = false,
  disabled = false,
}) {
  const [year = '', month = ''] = String(value || '').split('-');

  const years = useMemo(() => buildYears(10), []);

  const handleMonthChange = (event) => {
    const nextMonth = event.target.value;
    if (!nextMonth) {
      onChange('');
      return;
    }
    onChange(`${year || currentYear()}-${nextMonth}`);
  };

  const handleYearChange = (event) => {
    const nextYear = event.target.value;
    if (!nextYear) {
      onChange('');
      return;
    }
    onChange(`${nextYear}-${month || '01'}`);
  };

  const fieldClass = `${ui.select} appearance-none ${error ? 'border-danger focus:border-danger focus:ring-danger/20' : ''}`;

  return (
    <div className="space-y-2">
      <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
        <div>
          <label htmlFor={`${id}-month`} className="sr-only">Mês</label>
          <div className="relative">
            <select
              id={`${id}-month`}
              value={month}
              onChange={handleMonthChange}
              disabled={disabled}
              className={`${fieldClass} pr-10`}
            >
              <option value="">Mês</option>
              {MONTHS.map((item) => (
                <option key={item.value} value={item.value}>
                  {item.label}
                </option>
              ))}
            </select>
            <Calendar
              size={16}
              className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-muted"
            />
          </div>
        </div>

        <div>
          <label htmlFor={`${id}-year`} className="sr-only">Ano</label>
          <select
            id={`${id}-year`}
            value={year}
            onChange={handleYearChange}
            disabled={disabled}
            className={fieldClass}
          >
            <option value="">Ano</option>
            {years.map((item) => (
              <option key={item} value={String(item)}>
                {item}
              </option>
            ))}
          </select>
        </div>
      </div>

      {value && (
        <p className="text-xs text-muted">
          Competência selecionada: <span className="font-medium text-text">{formatPreview(value)}</span>
        </p>
      )}
    </div>
  );
}

function formatPreview(value) {
  const [year, month] = String(value).split('-');
  const monthItem = MONTHS.find((item) => item.value === month);
  if (!year || !monthItem) return value;
  return `${monthItem.label}/${year}`;
}
